import React from 'react';
import { Container, Typography, Box, Paper } from '@mui/material';

const Terms = () => {
  return (
    <Box sx={{ minHeight: '100vh', py: 4 }}>
      <Container maxWidth="lg">
        <Paper 
          elevation={12}
          sx={{ 
            borderRadius: 6,
            backgroundColor: '#ffffff',
            background: '#ffffff',
            boxShadow: '0 25px 50px rgba(0,0,0,0.25)',
            border: '2px solid rgba(0,0,0,0.1)',
            p: { xs: 4, sm: 6, md: 8 },
            position: 'relative',
            zIndex: 1
          }}
        >
          <Typography 
            variant="h4" 
            component="h1" 
            gutterBottom
            sx={{ 
              background: 'linear-gradient(135deg, #ff6b6b 0%, #ee5a24 50%, #e55039 100%)',
              backgroundClip: 'text',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              fontWeight: 800,
              textAlign: 'center',
              mb: 4
            }}
          >
            Podmínky používání
          </Typography>
          
          <Typography variant="h5" gutterBottom sx={{ color: '#333', fontWeight: 600, mt: 4, mb: 2 }}>
            1. Úvod
          </Typography>
          <Typography paragraph sx={{ fontSize: '1.1rem', lineHeight: 1.6, mb: 3, color: '#333' }}>
            Vítejte v aplikaci Nechci Lepek ("my", "naše", "nás"). Tyto podmínky používání upravují vaše používání naší aplikace. Používáním naší aplikace souhlasíte s těmito podmínkami v plném rozsahu. Pokud s těmito podmínkami nebo jejich částí nesouhlasíte, nesmíte naši aplikaci používat.
          </Typography>
          
          <Typography variant="h5" gutterBottom sx={{ color: '#333', fontWeight: 600, mt: 4, mb: 2 }}>
            2. Používání aplikace
          </Typography>
          <Typography paragraph sx={{ lineHeight: 1.6, mb: 3, color: '#333' }}>
            Naše aplikace poskytuje informace o potravinářských produktech na základě skenování čárových kódů. Tyto informace jsou získávány z veřejných databází (např. Open Food Facts) a jsou poskytovány pouze pro informační účely. Nezaručujeme přesnost, úplnost nebo vhodnost jakýchkoli poskytovaných informací. Jste odpovědní za ověření všech informací, zejména týkajících se alergenů a dietních omezení, u výrobce produktu.
          </Typography>
          
          <Typography variant="h5" gutterBottom sx={{ color: '#333', fontWeight: 600, mt: 4, mb: 2 }}>
            3. Vyloučení záruk
          </Typography>
          <Typography paragraph sx={{ lineHeight: 1.6, mb: 3, color: '#333' }}>
            Aplikace je poskytována "tak jak je" bez jakýchkoli prohlášení nebo záruk, výslovných nebo předpokládaných. Neposkytujeme žádná prohlášení nebo záruky ve vztahu k této aplikaci nebo poskytovaným informacím a materiálům. Neměli byste se spoléhat na informace z této aplikace jako na alternativu k lékařské radě od vašeho lékaře nebo jiného odborného poskytovatele zdravotní péče.
          </Typography>
          
          <Typography variant="h5" gutterBottom sx={{ color: '#333', fontWeight: 600, mt: 4, mb: 2 }}>
            4. Omezení odpovědnosti
          </Typography>
          <Typography paragraph sx={{ lineHeight: 1.6, mb: 3, color: '#333' }}>
            Nebudeme vám odpovědni ve vztahu k obsahu nebo používání této aplikace nebo jinak v souvislosti s touto aplikací za jakékoli nepřímé, zvláštní nebo následné ztráty; nebo za jakékoli obchodní ztráty, ztrátu příjmů, zisku nebo očekávaných úspor, ztrátu smluv nebo obchodních vztahů, ztrátu reputace nebo dobré pověsti, nebo ztrátu nebo poškození informací nebo dat.
          </Typography>
          
          <Typography variant="h5" gutterBottom sx={{ color: '#333', fontWeight: 600, mt: 4, mb: 2 }}>
            5. Změny těchto podmínek
          </Typography>
          <Typography paragraph sx={{ lineHeight: 1.6, mb: 3, color: '#333' }}>
            Naše podmínky používání můžeme čas od času aktualizovat. O jakýchkoli změnách vás budeme informovat zveřejněním nových podmínek používání na této stránce. Doporučujeme vám pravidelně kontrolovat tuto stránku kvůli případným změnám.
          </Typography>
          
          <Typography 
            paragraph 
            sx={{ 
              mt: 4, 
              pt: 3, 
              borderTop: '1px solid rgba(0,0,0,0.1)', 
              fontStyle: 'italic',
              color: '#666'
            }}
          >
            Naposledy aktualizováno: {new Date().toLocaleDateString('cs-CZ')}
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
};

export default Terms;
